import React from 'react'
import Bredcom from '../Bredcom/Main' 
import Header from '../headerone/Main' 


 
function StudentDisciplineCommittee() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="Student Discipline Committee" />
        <section className="project-detail">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="text-column col-lg-12 col-md-12 col-sm-12">                               
                                <div className="inner-column">
                                    <h2>Student Discipline Committee</h2>
                                    <table className="table table-bordered mb-40">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Ramveer Singh</td>
                                                <td>Chairmain</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Dean/HOD of the concerned School/Department</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Dr. Tarun Virmani</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Ms. Babita Yadav</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Mr Ram Kumar</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>Mr Himanshu Pal (B.Sc. (Bio Tech))</td>
                                                <td>Student Representative (UG)</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>Ms Prachi Saini (M.Pharm)</td>
                                                <td>Student Representative (PG)</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Registrar</td>
                                                <td>Member Secretary</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        
    </> 
  ) 
} 
 
export default StudentDisciplineCommittee 